import {
    RequestConfigFunction,
} from 'app/types/request.types'

type PharmaLeasePricingRequests = {
    domainName: string,
    create: RequestConfigFunction<undefined>,
    update: RequestConfigFunction<{id: number}>,
    get: RequestConfigFunction<{id: number}>,
}

const pharmaLeasePricingRequests: PharmaLeasePricingRequests = {
    domainName: 'pharmaleasepricing',
    create: () => {
        return {
            url: 'pharmaleasepricing',
            method: 'POST',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `pharmaleasepricing/${id}`,
            method: 'PUT',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `pharmaleasepricing/${id}`,
            method: 'GET',
        }
    },
}

export default pharmaLeasePricingRequests
